import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {SyncOutlined} from '@material-ui/icons';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import {useToast} from '../../../shared/toast/ToastProvider.tsx';
import TabelaProcessosSeletivos from '../../components/inscricao/TabelaProcessosSeletivos.jsx';
import useCarregamentoPagina from '../../components/useCarregamentoPagina.js';
import useCreateFile from '../../../../hooks/useCreateFile.js';
import {salvarArquivoResposta} from '../../../../utils/download.js';
import {URL_INSCRICOES_ARQUIVOS_ATUALIZAR_PS} from '../../../../constants/index.js';

const CORPO = {};

const useStyles = makeStyles(() => ({
    root: {
        width: 800,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'}
}));

/*
 * Atualiza o PS de inscrição dos inscritos não selecionados do processo escolhido (módulo
 * CFATUPSINS) e baixa a planilha dos atualizados. Sem inscritos a atualizar, o back responde 400.
 */
export default function DialogAtualizarPsInscricoes(props) {
    const {open, onClose} = props;
    const classes = useStyles();
    const {createToast} = useToast();
    const [createFile, atualizando] = useCreateFile({returnInnerLoadingState: true});

    // Geração do arquivo pelo LoadingModal global (sem spinner dentro do diálogo).
    useCarregamentoPagina(atualizando);
    const [processo, setProcesso] = useState(null);

    // Cada abertura começa sem processo escolhido.
    useEffect(() => {
        if (open) {
            setProcesso(null);
        }
    }, [open]);

    const handleAtualizar = () => {
        createFile(URL_INSCRICOES_ARQUIVOS_ATUALIZAR_PS(processo.id), CORPO, response => {
            salvarArquivoResposta(response, 'inscritos-atualizados.xls');
            createToast({severity: 'success', message: 'Inscritos atualizados com sucesso!'});
            onClose();
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-atualizar-ps-titulo'>
            <DialogTitle id='dialog-atualizar-ps-titulo'>Atualizar PS Inscrição não Selecionado</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <TabelaProcessosSeletivos onSelecionar={setProcesso}/>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <ContainedButton
                    startIcon={<SyncOutlined/>}
                    disabled={atualizando || !processo}
                    onClick={handleAtualizar}>
                    Atualizar PS Inscrições
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogAtualizarPsInscricoes.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
